import { FlowParameterEventFieldsFragment } from '~/graphql/types';
import { AppVBOWaardecheckReportPointerParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';
import { assertNever } from '~/util/assertion';
import cleanedFilename from '~/util/cleanedFilename';

import { PARAMETER_VALUE_TYPE } from '../../../constants';
import emptyVBOWaardecheckReportEventParameterValue from './emptyVBOWaardecheckReportEventParameterValue';

export default (
  eventVBOWaardecheckReportParameter:
    | Extract<
        FlowParameterEventFieldsFragment,
        {
          __typename: 'Flow_Parameter_Event_Contact_App_VBOWaardecheck_Report_Pointer';
        }
      >
    | null
    | undefined,
): AppVBOWaardecheckReportPointerParameterValue => {
  if (eventVBOWaardecheckReportParameter == null) {
    return emptyVBOWaardecheckReportEventParameterValue();
  }
  switch (eventVBOWaardecheckReportParameter.__typename) {
    case 'Flow_Parameter_Event_Contact_App_VBOWaardecheck_Report_Pointer':
      return {
        type: PARAMETER_VALUE_TYPE.EVENT_CONTACT_APP_VBOWAARDECHECK_REPORT_POINTER,
        variable: {
          name: eventVBOWaardecheckReportParameter.variable,
          field: eventVBOWaardecheckReportParameter.field
            ? {
                name: eventVBOWaardecheckReportParameter.field,
              }
            : null,
        },
      };
    default:
      return assertNever(
        eventVBOWaardecheckReportParameter.__typename,
        cleanedFilename(__filename),
      );
  }
};
